import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import {oeUniqueIdGen} from '../../../../lib/tools/oe-unique-id-gen';
import OEIcon from '../../../elements/oe-icon';
import {OEGroupControl, OEControl} from '../../../elements/controls/oe-controls';
import {OEIconButton} from '../../../elements/controls/oe-button';
import {OEIconButtonGroup} from '../../../elements/controls/oe-button-group';
import OEObjectModelValueEdit from '../../../elements/object-model-value-edit/oe-object-model-value-edit';
import {OESmartAttributeType, OESmartAttributeChangeFlags, OESmartAttributeControllerBtnIds, OESmartAttributeParameterModel, OESmartAttributeHelper, OESmartAttributeProps} from './oe-smart-attribute-model';

export default class OESmartAttributeCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.uid = oeUniqueIdGen.get();
        this.popoverTargetId = 'smart-attribute-cell-popover-target-id-' + this.uid;

        this.state = {
            icon:                   this.getIcon(),
            userRefObject:          {userRef: this.props.attribute.userRef},
            parameterModel:         this.getParameterModel(),
            strings: {
                signals:            'Signals',
                events:             'Events'
            }
        };

        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onUserRefChange = this.onUserRefChange.bind(this);
        this.onParameterChange = this.onParameterChange.bind(this);
        this.onEventFuncButtonPressed = this.onEventFuncButtonPressed.bind(this);
    }

    getIcon(props)  {
        props = props || this.props;
        return props.iconForType(props.attribute.type);
    }

    getParameterModel(props)   {
        props = props || this.props;
        return props.parameterModelForType(props.attribute.type);
    }

    componentWillReceiveProps(nextProps)    {
        let needsIconUpdate = false;

        if(nextProps.attribute.type !== this.props.attribute.type || nextProps.parameterModelForType !== this.props.parameterModelForType)    {
            this.setState({parameterModel: this.getParameterModel(nextProps)});
            needsIconUpdate = true;
        }

        if(nextProps.attribute.userRef !== this.props.attribute.userRef)    {
            this.setState({userRefObject: {userRef: nextProps.attribute.userRef}});
        }

        if(nextProps.iconForType !== this.props.iconForType)    {
            needsIconUpdate = true;
        }

        if(needsIconUpdate) {
            this.setState({icon: this.getIcon(nextProps)});
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        if(!this.oe.isReady())  return;

        this.setState({
            strings: {
                signals:        this.oe.sharedInterface.getLocalizedStringEnc('smart_attribute_cell_signals'),
                events:         this.oe.sharedInterface.getLocalizedStringEnc('smart_attribute_cell_events')
            }
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released)   {
            return;
        }

        this.updateLanguage();
    }

    renderSignals() {
        if(!Array.isArray(this.props.attribute.signals) || !this.props.attribute.signals.length)   return null;

        let signals = this.props.attribute.signals.map((signal, index) => <div key={index} className="smart-attribute-signal">{signal.name}</div>);

        return (
            <OEControl className="smart-attribute-signals" title={this.state.strings.signals}>
                {signals}
            </OEControl>
        );
    }

    renderEvents() {
        if(!Array.isArray(this.props.attribute.events) || !this.props.attribute.events.length)   return null;

        let events = this.props.attribute.events.map((event, index) => {
            let id = `${this.popoverTargetId}-attribute-${this.props.attribute.id}-event-${index}`;
            return (
                <div key={index} className="smart-attribute-event">
                    <span>{event.name}</span>
                    <OEIconButton
                        popoverTargetId={id}
                        eventIndex={index}
                        disabled={this.props.disabled}
                        activated={this.props.eventFuncButtonActivated === index}
                        icon={OEIconCodes.smartAttribute.eventFuncEdit}
                        onPressed={this.onEventFuncButtonPressed}
                    >
                        <div className="smart-attribute-event-popover-target" id={id}/>
                    </OEIconButton>
                </div>
            )
        });

        return (
            <OEControl className="smart-attribute-events" title={this.state.strings.events}>
                {events}
            </OEControl>
        );
    }

    render() {

        let buttons = [];
        if(this.props.onDumpBtnPressed) {
            buttons.push(
                {
                    id:         OESmartAttributeControllerBtnIds.dumpAttribute,
                    icon:       OEIconCodes.smartAttribute.dumpAttribute,
                    disabled:   this.props.disabled
                }
            );
        }

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className="smart-attribute-cell" id={this.popoverTargetId}>

                    <div className="content">

                        <OEGroupControl>

                            <OEControl className="smart-attribute-bar">
                                <OEIcon className="smart-attribute-type" code={this.state.icon}/>

                                <OEIconButtonGroup
                                    buttons={buttons}
                                    onPressed={this.onButtonPressed}
                                />
                            </OEControl>

                            <OEControl>
                                <OEObjectModelValueEdit moduleId={this.props.moduleId} disabled={this.props.disabled} model={OESmartAttributeParameterModel.userRef} object={this.state.userRefObject} onChange={this.onUserRefChange}/>
                            </OEControl>

                            <OEControl>
                                <OEObjectModelValueEdit moduleId={this.props.moduleId} disabled={this.props.disabled} model={this.state.parameterModel} object={this.props.attribute.params} onChange={this.onParameterChange}/>
                            </OEControl>

                            {this.renderSignals()}

                            {this.renderEvents()}

                        </OEGroupControl>

                    </div>

                    {this.props.showSeparator ? <div className="std-separator-border-color separator"/> : null}

                </div>

            </React.Fragment>
        );
    }

    onButtonPressed(sender, id)  {
        if(id === OESmartAttributeControllerBtnIds.dumpAttribute)   {
            if(this.props.onDumpBtnPressed) this.props.onDumpBtnPressed(this, this.props.attribute.id);
        }
    }

    onUserRefChange(sender, object)   {
        if(!this.props.onChange)   return;
        let attribute = clone(this.props.attribute);
        attribute.userRef = object.userRef;
        this.props.onChange(this, attribute, OESmartAttributeChangeFlags.userRef);
    }

    onParameterChange(sender, params)   {
        if(!this.props.onChange)   return;
        let attribute = clone(this.props.attribute);
        attribute.params = Object.assign(attribute.params ? attribute.params : {}, params);
        this.props.onChange(this, attribute, OESmartAttributeChangeFlags.params);
    }

    onEventFuncButtonPressed(event, sender) {
        if(this.props.onEventFuncBtnPressed)   this.props.onEventFuncBtnPressed(this, this.props.attribute.id, sender.props.eventIndex, sender.props.popoverTargetId);
    }
}

OESmartAttributeCell.defaultProps = {
    moduleId:                   '',
    showSeparator:              false,
    disabled:                   false,
    attribute:                  {id: -1, type: OESmartAttributeType.noOp},
    eventFuncButtonActivated:   -1,
    iconForType:                OESmartAttributeHelper.iconForType,
    parameterModelForType:      OESmartAttributeHelper.parameterModelForType,
};

OESmartAttributeCell.propTypes = {
    moduleId:                   PropTypes.string,
    popoverClassName:           PropTypes.string,
    showSeparator:              PropTypes.bool,
    disabled:                   PropTypes.bool,
    attribute:                  OESmartAttributeProps.attribute,
    eventFuncButtonActivated:   PropTypes.number,
    iconForType:                PropTypes.func,
    parameterModelForType:      PropTypes.func,
    onChange:                   PropTypes.func,
    onDumpBtnPressed:           PropTypes.func,
    onEventFuncBtnPressed:      PropTypes.func
};